import React from 'react';
import { DatePickerType } from '../types';
import { DatePickerTypeLabel } from '../utils';
import * as DatePickerTypeListUI from './DatePickerTypeListUI';

interface IProps {
  selectedDatePickerType: DatePickerType;
  datePickerType: DatePickerType;
  onChange: (newType: DatePickerType) => void;
}
const DatePickerTypeListItem = ({
  selectedDatePickerType,
  datePickerType,
  onChange,
}: IProps) => (
  <DatePickerTypeListUI.ListItem
    onClick={() => onChange(datePickerType)}
    $isActive={datePickerType === selectedDatePickerType}
  >
    {DatePickerTypeLabel[datePickerType]}
  </DatePickerTypeListUI.ListItem>
);

export default DatePickerTypeListItem;
